import useDealer from "hooks/useDealer";
import DealerUsers from "views/Dealers/Tabs/DealerUsers";

// core components
import PageLayout from "layouts/PageLayout";

export default function DealerUsersView({ ...otherProps }) {
    const dealer = useDealer();

    return (
        <PageLayout {...otherProps} showSelectDealer={false}>
            <DealerUsers dlid={dealer.id} {...otherProps} />
        </PageLayout>
    );
}
